import React from 'react';
import './TimeOffRequestForm.scss';
import { FormLabel } from '../common/forms/FormElements';
import Select from 'react-select';
import { isReadOnly } from './TimeOffRequest';
import { FormGroup } from 'reactstrap';

export default class TimeOffReasonSelect extends React.Component {
    onTimeOffReasonChanged = (e) => {
        if (!e || !e.id) {
            return;
        }

        const { timeOffRequest, onTimeOffRequestMutated } = this.props;

        timeOffRequest.timeOffReasonId = e.id;

        onTimeOffRequestMutated(timeOffRequest);
    };

    render() {
        const { loading, timeOffRequest, timeOffReasons } = this.props;

        if (loading) {
            return null;
        }

        const readOnly = isReadOnly(timeOffRequest);

        const timeOffReason = timeOffReasons.find(
            (tor) => timeOffRequest.timeOffReasonId == tor.id
        );

        return (
            <FormGroup className="tor-form-group mr-3">
                <FormLabel text="Reason" required />

                {!readOnly && (
                    <Select
                        options={timeOffReasons}
                        onChange={this.onTimeOffReasonChanged}
                        getOptionLabel={(tor) => tor.name}
                        getOptionValue={(tor) => tor.id}
                        value={
                            timeOffReasons.find(
                                (tor) =>
                                    tor.id == timeOffRequest.timeOffReasonId
                            ) ?? ''
                        }
                    />
                )}

                {readOnly && timeOffReason && <>{timeOffReason.name}</>}
            </FormGroup>
        );
    }
}
